import { AmountWithUnit, GetInvoicesSummaryResponseBody } from '@/hooks'
import { faker } from '@faker-js/faker'

const generateAmountWithUnit = (
    min: number,
    max: number,
    unit = 'USD'
): AmountWithUnit => ({
    value: faker.number.int({ min, max }),
    unit,
})

const generateInvoiceSummary =
    (): GetInvoicesSummaryResponseBody['currentYear'] => ({
        usage: generateAmountWithUnit(100, 1000, 'kWh'),
        cost: generateAmountWithUnit(100, 5000, 'USD'),
        count: faker.number.int({ min: 1, max: 100 }),
        dateRange: {
            startDate: faker.date.past().toISOString(),
            endDate: faker.date.recent().toISOString(),
        },
    })

export const generateInvoicesSummaryResponse =
    (): GetInvoicesSummaryResponseBody => ({
        currentYear: generateInvoiceSummary(),
        lastYear: generateInvoiceSummary(),
    })
